export default {
    en: {
        recordAVideo: 'Record a video',
        videoRecorder: 'Video recorder',
        camera: 'Camera',
        noCamera: 'No camera',
        microphone: 'Microphone',
        noAudio: 'No audio',
        timeLimitReached: 'Time limit reached, stopping recording',
        loadingMoment: 'Loading, this may take a moment',
        recordingLimit: 'Recording limit: {formattedTime} (at which point your video will be automatically closed)',
        startRecording: 'Start recording',
        screenSharingMandatory: 'Screen sharing is <strong>mandatory</strong>',
        cameraNotRecorded: 'Camera will <strong>not</strong> be recorded',
        cameraRecorded: 'Camera will be <strong>recorded</strong>',
        audioNotRecorded: 'Audio will <strong>not</strong> be recorded',
        audioRecorded: 'Audio will be <strong>recorded</strong>',
        screenSharingOptional: 'Screen sharing is <strong>optional</strong>',
        prompt: 'Prompt',
        textResponsePlaceholder: 'Please enter any text response to this question here',
        adminFunctionalityDisabled: 'Functionality disabled in admin area',
        unnamedCamera: 'Unnamed Camera',
        unnamedMicrophone: 'Unnamed Microphone',
        minute_singular: '{count} minute',
        minute_plural: '{count} minutes',
        second_singular: '{count} second',
        second_plural: '{count} seconds',
        totalFileSize: 'Total file size',
        browserSupport: 'Your browser does not support the video tag.',
        chooseFiles: '<strong>Choose</strong> your files or <strong>drag</strong> them here',
    },
    in: {
        recordAVideo: 'Rekam video',
        videoRecorder: 'Perekam video',
        camera: 'Kamera',
        noCamera: 'Tanpa kamera',
        microphone: 'Mikrofon',
        noAudio: 'Tanpa audio',
        timeLimitReached: 'Batas waktu tercapai, menghentikan perekaman',
        loadingMoment: 'Memuat, ini mungkin memakan waktu sebentar',
        recordingLimit: 'Batas perekaman: {formattedTime} (setelah itu video Anda akan ditutup secara otomatis)',
        startRecording: 'Mulai merekam',
        screenSharingMandatory: 'Berbagi layar <strong>wajib</strong>',
        cameraNotRecorded: 'Kamera <strong>tidak akan</strong> direkam',
        cameraRecorded: 'Kamera akan <strong>direkam</strong>',
        audioNotRecorded: 'Audio <strong>tidak akan</strong> direkam',
        audioRecorded: 'Audio akan <strong>direkam</strong>',
        screenSharingOptional: 'Berbagi layar <strong>opsional</strong>',
        prompt: 'Petunjuk',
        textResponsePlaceholder: 'Masukkan tanggapan teks untuk pertanyaan ini di sini',
        adminFunctionalityDisabled: 'Fungsi dinonaktifkan di area admin',
        unnamedCamera: 'Kamera tanpa nama',
        unnamedMicrophone: 'Mikrofon tanpa nama',
        minute_singular: '{count} menit',
        minute_plural: '{count} menit',
        second_singular: '{count} detik',
        second_plural: '{count} detik',
        totalFileSize: 'Ukuran total file',
        browserSupport: 'Peramban Anda tidak mendukung tag video.',
        chooseFiles: '<strong>Pilih</strong> file Anda atau <strong>seret</strong> ke sini',
    },
    zh: {
        recordAVideo: '录制视频',
        videoRecorder: '视频录制器',
        camera: '摄像头',
        noCamera: '无摄像头',
        microphone: '麦克风',
        noAudio: '无音频',
        timeLimitReached: '达到时间限制，停止录制',
        loadingMoment: '加载中，请稍候',
        recordingLimit: '录制限制：{formattedTime} （到达后视频将自动关闭）',
        startRecording: '开始录制',
        screenSharingMandatory: '屏幕共享为<strong>必需</strong>',
        cameraNotRecorded: '摄像头<strong>不会</strong>被录制',
        cameraRecorded: '摄像头将<strong>被录制</strong>',
        audioNotRecorded: '音频<strong>不会</strong>被录制',
        audioRecorded: '音频将<strong>被录制</strong>',
        screenSharingOptional: '屏幕共享为<strong>可选</strong>',
        prompt: '提示',
        textResponsePlaceholder: '请在此输入电子邮件地址',
        adminFunctionalityDisabled: '管理员区域功能已禁用',
        unnamedCamera: '未命名摄像头',
        unnamedMicrophone: '未命名麦克风',
        minute_singular: '{count} 分钟',
        minute_plural: '{count} 分钟',
        second_singular: '{count} 秒',
        second_plural: '{count} 秒',
        totalFileSize: '总文件大小',
        browserSupport: '您的浏览器不支持 video 标签。',
        chooseFiles: '<strong>选择</strong>您的文件或<strong>拖拽</strong>到此处',
    },
    nl: {
        recordAVideo: 'Neem een video op',
        videoRecorder: 'Videorecorder',
        camera: 'Camera',
        noCamera: 'Geen camera',
        microphone: 'Microfoon',
        noAudio: 'Geen audio',
        timeLimitReached: 'Tijdslimiet bereikt, stoppen met opnemen',
        loadingMoment: 'Laden, dit kan even duren',
        recordingLimit: 'Opnamelimiet: {formattedTime} (waarop uw video automatisch wordt gesloten)',
        startRecording: 'Begin met opnemen',
        screenSharingMandatory: 'Scherm delen is <strong>verplicht</strong>',
        cameraNotRecorded: 'Camera wordt <strong>niet</strong> opgenomen',
        cameraRecorded: 'Camera wordt <strong>opgenomen</strong>',
        audioNotRecorded: 'Audio wordt <strong>niet</strong> opgenomen',
        audioRecorded: 'Audio wordt <strong>opgenomen</strong>',
        screenSharingOptional: 'Scherm delen is <strong>optioneel</strong>',
        prompt: 'Opdracht',
        textResponsePlaceholder: 'Voer hier een tekstuele reactie op deze vraag in',
        adminFunctionalityDisabled: 'Functionaliteit uitgeschakeld in admin gebied',
        unnamedCamera: 'Naamloze camera',
        unnamedMicrophone: 'Naamloze microfoon',
        minute_singular: '{count} minuut',
        minute_plural: '{count} minuten',
        second_singular: '{count} seconde',
        second_plural: '{count} seconden',
        totalFileSize: 'Totale bestandsgrootte',
        browserSupport: 'Uw browser ondersteunt het video-element niet.',
        chooseFiles: '<strong>Kies</strong> uw bestanden of <strong>sleep</strong> ze hierheen',
    },
    fi: {
        recordAVideo: 'Tallenna video',
        videoRecorder: 'Videon tallentaja',
        camera: 'Kamera',
        noCamera: 'Ei kameraa',
        microphone: 'Mikrofoni',
        noAudio: 'Ei ääntä',
        timeLimitReached: 'Aikaraja saavutettu, pysäytetään tallennus',
        loadingMoment: 'Ladataan, tämä voi kestää hetken',
        recordingLimit: 'Tallennusrajoitus: {formattedTime} (sen jälkeen videosi suljetaan automaattisesti)',
        startRecording: 'Aloita tallennus',
        screenSharingMandatory: 'Näytön jakaminen on <strong>pakollista</strong>',
        cameraNotRecorded: 'Kameraa <strong>ei tallenneta</strong>',
        cameraRecorded: 'Kamera tallennetaan',
        audioNotRecorded: 'Ääntä <strong>ei tallenneta</strong>',
        audioRecorded: 'Ääni tallennetaan',
        screenSharingOptional: 'Näytön jakaminen on <strong>valinnainen</strong>',
        prompt: 'Kehoitus',
        textResponsePlaceholder: 'Syötä tekstivastaus kysymykseen tähän',
        adminFunctionalityDisabled: 'Toiminto on pois käytöstä ylläpitäjäalueella',
        unnamedCamera: 'Nimetön kamera',
        unnamedMicrophone: 'Nimetön mikrofoni',
        minute_singular: '{count} minuutti',
        minute_plural: '{count} minuuttia',
        second_singular: '{count} sekunti',
        second_plural: '{count} sekuntia',
        totalFileSize: 'Kokonaiskoko',
        browserSupport: 'Selaimesi ei tue videoelementtiä.',
        chooseFiles: '<strong>Valitse</strong> tiedostot tai <strong>raahaa</strong> ne tähän',
    },
    fr: {
        recordAVideo: 'Enregistrer une vidéo',
        videoRecorder: 'Enregistreur vidéo',
        camera: 'Caméra',
        noCamera: 'Pas de caméra',
        microphone: 'Microphone',
        noAudio: 'Pas de son',
        timeLimitReached: "Limite de temps atteinte, arrêt de l'enregistrement",
        loadingMoment: 'Chargement, cela peut prendre un moment',
        recordingLimit: "Limite d'enregistrement : {formattedTime} (après quoi votre vidéo sera automatiquement fermée)",
        startRecording: 'Démarrer l’enregistrement',
        screenSharingMandatory: 'Le partage d’écran est <strong>obligatoire</strong>',
        cameraNotRecorded: 'La caméra ne sera <strong>pas</strong> enregistrée',
        cameraRecorded: 'La caméra sera <strong>enregistrée</strong>',
        audioNotRecorded: "L’audio ne sera <strong>pas</strong> enregistré",
        audioRecorded: "L’audio sera <strong>enregistré</strong>",
        screenSharingOptional: 'Le partage d’écran est <strong>optionnel</strong>',
        prompt: 'Invite',
        textResponsePlaceholder: 'Veuillez saisir ici votre réponse textuelle à cette question',
        adminFunctionalityDisabled: 'Fonctionnalité désactivée dans la zone admin',
        unnamedCamera: 'Caméra sans nom',
        unnamedMicrophone: 'Microphone sans nom',
        minute_singular: '{count} minute',
        minute_plural: '{count} minutes',
        second_singular: '{count} seconde',
        second_plural: '{count} secondes',
        totalFileSize: 'Taille totale du fichier',
        browserSupport: 'Votre navigateur ne prend pas en charge la balise vidéo.',
        chooseFiles: '<strong>Choisissez</strong> vos fichiers ou <strong>glissez-les</strong> ici',
    },
    de: {
        recordAVideo: 'Video aufnehmen',
        videoRecorder: 'Videorekorder',
        camera: 'Kamera',
        noCamera: 'Keine Kamera',
        microphone: 'Mikrofon',
        noAudio: 'Kein Audio',
        timeLimitReached: 'Zeitlimit erreicht, Aufnahme wird gestoppt',
        loadingMoment: 'Laden, dies kann einen Moment dauern',
        recordingLimit: 'Aufnahmebegrenzung: {formattedTime} (danach wird Ihr Video automatisch geschlossen)',
        startRecording: 'Aufnahme starten',
        screenSharingMandatory: 'Bildschirmfreigabe ist <strong>verpflichtend</strong>',
        cameraNotRecorded: 'Kamera wird <strong>nicht</strong> aufgezeichnet',
        cameraRecorded: 'Kamera wird <strong>aufgezeichnet</strong>',
        audioNotRecorded: 'Audio wird <strong>nicht</strong> aufgezeichnet',
        audioRecorded: 'Audio wird <strong>aufgezeichnet</strong>',
        screenSharingOptional: 'Bildschirmfreigabe ist <strong>optional</strong>',
        prompt: 'Aufforderung',
        textResponsePlaceholder: 'Bitte geben Sie hier Ihre textuelle Antwort auf diese Frage ein',
        adminFunctionalityDisabled: 'Funktionalität im Admin-Bereich deaktiviert',
        unnamedCamera: 'Unbenannte Kamera',
        unnamedMicrophone: 'Unbenanntes Mikrofon',
        minute_singular: '{count} Minute',
        minute_plural: '{count} Minuten',
        second_singular: '{count} Sekunde',
        second_plural: '{count} Sekunden',
        totalFileSize: 'Gesamtdateigröße',
        browserSupport: 'Ihr Browser unterstützt das Video-Tag nicht.',
        chooseFiles: '<strong>Wählen</strong> Sie Ihre Dateien oder <strong>ziehen</strong> Sie sie hierher',
    },
    hi: {
        recordAVideo: 'वीडियो रिकॉर्ड करें',
        videoRecorder: 'वीडियो रिकॉर्डर',
        camera: 'कैमरा',
        noCamera: 'कोई कैमरा नहीं',
        microphone: 'माइक्रोफ़ोन',
        noAudio: 'कोई ऑडियो नहीं',
        timeLimitReached: 'समय सीमा पार, रिकॉर्डिंग बंद की जा रही है',
        loadingMoment: 'लोड हो रहा है, कृपया प्रतीक्षा करें',
        recordingLimit: 'रिकॉर्डिंग सीमा: {formattedTime} (इसके बाद आपका वीडियो स्वचालित रूप से बंद हो जाएगा)',
        startRecording: 'रिकॉर्डिंग शुरू करें',
        screenSharingMandatory: 'स्क्रीन शेयरिंग <strong>अनिवार्य</strong> है',
        cameraNotRecorded: 'कैमरा <strong>रिकॉर्ड नहीं</strong> किया जाएगा',
        cameraRecorded: 'कैमरा <strong>रिकॉर्ड</strong> किया जाएगा',
        audioNotRecorded: 'ऑडियो <strong>रिकॉर्ड नहीं</strong> किया जाएगा',
        audioRecorded: 'ऑडियो <strong>रिकॉर्ड</strong> किया जाएगा',
        screenSharingOptional: 'स्क्रीन शेयरिंग <strong>वैकल्पिक</strong> है',
        prompt: 'प्रॉम्प्ट',
        textResponsePlaceholder: 'कृपया इस प्रश्न का पाठ्य उत्तर यहाँ दर्ज करें',
        adminFunctionalityDisabled: 'एडमिन क्षेत्र में कार्यक्षमता अक्षम है',
        unnamedCamera: 'अनाम कैमरा',
        unnamedMicrophone: 'अनाम माइक्रोफ़ोन',
        minute_singular: '{count} मिनट',
        minute_plural: '{count} मिनट',
        second_singular: '{count} सेकंड',
        second_plural: '{count} सेकंड',
        totalFileSize: 'कुल फ़ाइल आकार',
        browserSupport: 'आपका ब्राउज़र वीडियो टैग का समर्थन नहीं करता है।',
        chooseFiles: '<strong>अपनी फ़ाइलें चुनें</strong> या उन्हें <strong>यहाँ खींचें</strong>',
    },
    it: {
        recordAVideo: 'Registra un video',
        videoRecorder: 'Registratore video',
        camera: 'Telecamera',
        noCamera: 'Nessuna telecamera',
        microphone: 'Microfono',
        noAudio: 'Nessun audio',
        timeLimitReached: 'Limite di tempo raggiunto, arresto della registrazione',
        loadingMoment: 'Caricamento in corso, attendere un momento',
        recordingLimit: 'Limite di registrazione: {formattedTime} (dopo il quale il video verrà chiuso automaticamente)',
        startRecording: 'Inizia la registrazione',
        screenSharingMandatory: 'La condivisione dello schermo è <strong>obbligatoria</strong>',
        cameraNotRecorded: 'La telecamera non verrà <strong>registrata</strong>',
        cameraRecorded: 'La telecamera verrà <strong>registrata</strong>',
        audioNotRecorded: 'L\'audio non verrà <strong>registrato</strong>',
        audioRecorded: 'L\'audio verrà <strong>registrato</strong>',
        screenSharingOptional: 'La condivisione dello schermo è <strong>facoltativa</strong>',
        prompt: 'Prompt',
        textResponsePlaceholder: 'Inserisci qui la tua risposta testuale a questa domanda',
        adminFunctionalityDisabled: 'Funzionalità disabilitata nell\'area admin',
        unnamedCamera: 'Telecamera senza nome',
        unnamedMicrophone: 'Microfono senza nome',
        minute_singular: '{count} minuto',
        minute_plural: '{count} minuti',
        second_singular: '{count} secondo',
        second_plural: '{count} secondi',
        totalFileSize: 'Dimensione totale del file',
        browserSupport: 'Il tuo browser non supporta il tag video.',
        chooseFiles: '<strong>Scegli</strong> i tuoi file o <strong>trascinali</strong> qui',
    },
    ja: {
        recordAVideo: 'ビデオを録画する',
        videoRecorder: 'ビデオレコーダー',
        camera: 'カメラ',
        noCamera: 'カメラなし',
        microphone: 'マイク',
        noAudio: '音声なし',
        timeLimitReached: '時間制限に達しました。録画を停止します',
        loadingMoment: '読み込み中です。少々お待ちください',
        recordingLimit: '録画制限：{formattedTime} （この時間を過ぎると、ビデオは自動的に閉じられます）',
        startRecording: '録画を開始',
        screenSharingMandatory: '画面共有は<strong>必須</strong>です',
        cameraNotRecorded: 'カメラは<strong>録画されません</strong>',
        cameraRecorded: 'カメラは<strong>録画されます</strong>',
        audioNotRecorded: '音声は<strong>録画されません</strong>',
        audioRecorded: '音声は<strong>録画されます</strong>',
        screenSharingOptional: '画面共有は<strong>任意</strong>です',
        prompt: 'プロンプト',
        textResponsePlaceholder: 'この質問に対するテキスト回答をここに入力してください',
        adminFunctionalityDisabled: '管理者エリアでは機能が無効になっています',
        unnamedCamera: '名前のないカメラ',
        unnamedMicrophone: '名前のないマイク',
        minute_singular: '{count} 分',
        minute_plural: '{count} 分',
        second_singular: '{count} 秒',
        second_plural: '{count} 秒',
        totalFileSize: 'ファイルの合計サイズ',
        browserSupport: 'お使いのブラウザは video タグをサポートしていません。',
        chooseFiles: '<strong>ファイルを選択</strong>するか、<strong>ここにドラッグ</strong>してください',
    },
    ko: {
        recordAVideo: '비디오 녹화하기',
        videoRecorder: '비디오 녹화기',
        camera: '카메라',
        noCamera: '카메라 없음',
        microphone: '마이크',
        noAudio: '오디오 없음',
        timeLimitReached: '시간 제한 도달, 녹화 중지',
        loadingMoment: '로딩 중, 잠시만 기다려주세요',
        recordingLimit: '녹화 제한: {formattedTime} (이 시간이 지나면 비디오가 자동으로 닫힙니다)',
        startRecording: '녹화를 시작',
        screenSharingMandatory: '화면 공유는 <strong>필수</strong>입니다',
        cameraNotRecorded: '카메라는 <strong>녹화되지 않습니다</strong>',
        cameraRecorded: '카메라는 <strong>녹화됩니다</strong>',
        audioNotRecorded: '오디오는 <strong>녹화되지 않습니다</strong>',
        audioRecorded: '오디오는 <strong>녹화됩니다</strong>',
        screenSharingOptional: '화면 공유는 <strong>선택 사항</strong>입니다',
        prompt: '프롬프트',
        textResponsePlaceholder: '이 질문에 대한 텍스트 응답을 여기에 입력하세요',
        adminFunctionalityDisabled: '관리자 영역에서는 기능이 비활성화되어 있습니다',
        unnamedCamera: '이름 없는 카메라',
        unnamedMicrophone: '이름 없는 마이크',
        minute_singular: '{count}분',
        minute_plural: '{count}분',
        second_singular: '{count}초',
        second_plural: '{count}초',
        totalFileSize: '총 파일 크기',
        browserSupport: '브라우저가 video 태그를 지원하지 않습니다.',
        chooseFiles: '<strong>파일을 선택</strong>하거나 <strong>여기로 드래그</strong>하세요',
    },
    pl: {
        recordAVideo: 'Nagraj wideo',
        videoRecorder: 'Rejestrator wideo',
        camera: 'Kamera',
        noCamera: 'Brak kamery',
        microphone: 'Mikrofon',
        noAudio: 'Brak dźwięku',
        timeLimitReached: 'Osiągnięto limit czasu, zatrzymywanie nagrywania',
        loadingMoment: 'Ładowanie, proszę czekać chwilę',
        recordingLimit: 'Limit nagrywania: {formattedTime} (po czym wideo zostanie automatycznie zamknięte)',
        startRecording: 'Rozpocznij nagrywanie',
        screenSharingMandatory: 'Udostępnianie ekranu jest <strong>obowiązkowe</strong>',
        cameraNotRecorded: 'Kamera nie zostanie <strong>nagrana</strong>',
        cameraRecorded: 'Kamera zostanie <strong>nagrana</strong>',
        audioNotRecorded: 'Audio nie zostanie <strong>nagrane</strong>',
        audioRecorded: 'Audio zostanie <strong>nagrane</strong>',
        screenSharingOptional: 'Udostępnianie ekranu jest <strong>opcjonalne</strong>',
        prompt: 'Polecenie',
        textResponsePlaceholder: 'Wprowadź tutaj swoją odpowiedź tekstową na to pytanie',
        adminFunctionalityDisabled: 'Funkcjonalność wyłączona w obszarze administratora',
        unnamedCamera: 'Bez nazwy (kamera)',
        unnamedMicrophone: 'Bez nazwy (mikrofon)',
        minute_singular: '{count} minuta',
        minute_plural: '{count} minuty',
        second_singular: '{count} sekunda',
        second_plural: '{count} sekundy',
        totalFileSize: 'Całkowity rozmiar pliku',
        browserSupport: 'Twoja przeglądarka nie obsługuje tagu video.',
        chooseFiles: '<strong>Wybierz</strong> pliki lub je <strong>przeciągnij</strong> tutaj',
    },
    pt: {
        recordAVideo: 'Gravar um vídeo',
        videoRecorder: 'Gravador de vídeo',
        camera: 'Câmera',
        noCamera: 'Sem câmera',
        microphone: 'Microfone',
        noAudio: 'Sem áudio',
        timeLimitReached: 'Limite de tempo atingido, interrompendo a gravação',
        loadingMoment: 'Carregando, isso pode levar um momento',
        recordingLimit: 'Limite de gravação: {formattedTime} (após o qual seu vídeo será fechado automaticamente)',
        startRecording: 'Iniciar gravação',
        screenSharingMandatory: 'O compartilhamento de tela é <strong>obrigatório</strong>',
        cameraNotRecorded: 'A câmera <strong>não será</strong> gravada',
        cameraRecorded: 'A câmera será <strong>gravada</strong>',
        audioNotRecorded: 'O áudio <strong>não será</strong> gravado',
        audioRecorded: 'O áudio será <strong>gravado</strong>',
        screenSharingOptional: 'O compartilhamento de tela é <strong>opcional</strong>',
        prompt: 'Prompt',
        textResponsePlaceholder: 'Por favor, insira sua resposta de texto para esta pergunta aqui',
        adminFunctionalityDisabled: 'Funcionalidade desativada na área de administração',
        unnamedCamera: 'Câmera sem nome',
        unnamedMicrophone: 'Microfone sem nome',
        minute_singular: '{count} minuto',
        minute_plural: '{count} minutos',
        second_singular: '{count} segundo',
        second_plural: '{count} segundos',
        totalFileSize: 'Tamanho total do arquivo',
        browserSupport: 'Seu navegador não suporta a tag de vídeo.',
        chooseFiles: '<strong>Escolha</strong> seus arquivos ou <strong>arraste-os</strong> para cá',
    },
    es: {
        recordAVideo: 'Grabar un video',
        videoRecorder: 'Grabadora de video',
        camera: 'Cámara',
        noCamera: 'Sin cámara',
        microphone: 'Micrófono',
        noAudio: 'Sin audio',
        timeLimitReached: 'Se alcanzó el límite de tiempo, deteniendo la grabación',
        loadingMoment: 'Cargando, esto puede tardar un momento',
        recordingLimit: 'Límite de grabación: {formattedTime} (tras lo cual tu video se cerrará automáticamente)',
        startRecording: 'Iniciar grabación',
        screenSharingMandatory: 'La compartición de pantalla es <strong>obligatoria</strong>',
        cameraNotRecorded: 'La cámara <strong>no se grabará</strong>',
        cameraRecorded: 'La cámara se <strong>grabará</strong>',
        audioNotRecorded: 'El audio <strong>no se grabará</strong>',
        audioRecorded: 'El audio se <strong>grabará</strong>',
        screenSharingOptional: 'La compartición de pantalla es <strong>opcional</strong>',
        prompt: 'Indicación',
        textResponsePlaceholder: 'Por favor, ingresa aquí tu respuesta en texto a esta pregunta',
        adminFunctionalityDisabled: 'Funcionalidad deshabilitada en el área de administración',
        unnamedCamera: 'Cámara sin nombre',
        unnamedMicrophone: 'Micrófono sin nombre',
        minute_singular: '{count} minuto',
        minute_plural: '{count} minutos',
        second_singular: '{count} segundo',
        second_plural: '{count} segundos',
        totalFileSize: 'Tamaño total del archivo',
        browserSupport: 'Tu navegador no admite la etiqueta de video.',
        chooseFiles: '<strong>Elige</strong> tus archivos o <strong>arrástralos</strong> aquí',
    },
    tr: {
        recordAVideo: 'Video kaydı yap',
        videoRecorder: 'Video kaydedici',
        camera: 'Kamera',
        noCamera: 'Kamera yok',
        microphone: 'Mikrofon',
        noAudio: 'Ses yok',
        timeLimitReached: 'Zaman sınırına ulaşıldı, kayıt durduruluyor',
        loadingMoment: 'Yükleniyor, lütfen bekleyin',
        recordingLimit: 'Kayıt limiti: {formattedTime} (bu süreden sonra videonuz otomatik olarak kapatılacaktır)',
        startRecording: 'Kaydı başlat',
        screenSharingMandatory: 'Ekran paylaşımı <strong>zorunludur</strong>',
        cameraNotRecorded: 'Kamera <strong>kaydedilmeyecek</strong>',
        cameraRecorded: 'Kamera <strong>kaydedilecek</strong>',
        audioNotRecorded: 'Ses <strong>kaydedilmeyecek</strong>',
        audioRecorded: 'Ses <strong>kaydedilecek</strong>',
        screenSharingOptional: 'Ekran paylaşımı <strong>opsiyoneldir</strong>',
        prompt: 'İpucu',
        textResponsePlaceholder: 'Lütfen bu soruya metin yanıtınızı buraya girin',
        adminFunctionalityDisabled: 'Yönetici alanında işlev devre dışı',
        unnamedCamera: 'Adsız Kamera',
        unnamedMicrophone: 'Adsız Mikrofon',
        minute_singular: '{count} dakika',
        minute_plural: '{count} dakika',
        second_singular: '{count} saniye',
        second_plural: '{count} saniye',
        totalFileSize: 'Toplam dosya boyutu',
        browserSupport: 'Tarayıcınız video etiketini desteklemiyor.',
        chooseFiles: '<strong>Dosyalarınızı seçin</strong> veya <strong>buraya sürükleyin</strong>',
    },
    vi: {
        recordAVideo: 'Ghi video',
        videoRecorder: 'Máy ghi video',
        camera: 'Camera',
        noCamera: 'Không có camera',
        microphone: 'Micrô',
        noAudio: 'Không có âm thanh',
        timeLimitReached: 'Đã đạt giới hạn thời gian, dừng ghi',
        loadingMoment: 'Đang tải, vui lòng chờ một chút',
        recordingLimit: 'Giới hạn ghi: {formattedTime} (sau thời gian này, video của bạn sẽ tự động đóng)',
        startRecording: 'Bắt đầu ghi',
        screenSharingMandatory: 'Chia sẻ màn hình là <strong>bắt buộc</strong>',
        cameraNotRecorded: 'Camera sẽ <strong>không được</strong> ghi',
        cameraRecorded: 'Camera sẽ được <strong>ghi</strong>',
        audioNotRecorded: 'Âm thanh sẽ <strong>không được</strong> ghi',
        audioRecorded: 'Âm thanh sẽ được <strong>ghi</strong>',
        screenSharingOptional: 'Chia sẻ màn hình là <strong>tùy chọn</strong>',
        prompt: 'Nhắc nhở',
        textResponsePlaceholder: 'Vui lòng nhập câu trả lời văn bản của bạn cho câu hỏi này ở đây',
        adminFunctionalityDisabled: 'Chức năng bị vô hiệu hóa trong khu vực quản trị',
        unnamedCamera: 'Camera không tên',
        unnamedMicrophone: 'Micrô không tên',
        minute_singular: '{count} phút',
        minute_plural: '{count} phút',
        second_singular: '{count} giây',
        second_plural: '{count} giây',
        totalFileSize: 'Tổng kích thước tệp',
        browserSupport: 'Trình duyệt của bạn không hỗ trợ thẻ video.',
        chooseFiles: '<strong>Chọn</strong> tệp của bạn hoặc <strong>kéo</strong> vào đây',
    },
    ar: {
        recordAVideo: 'تسجيل فيديو',
        videoRecorder: 'مسجل الفيديو',
        camera: 'الكاميرا',
        noCamera: 'لا توجد كاميرا',
        microphone: 'الميكروفون',
        noAudio: 'لا يوجد صوت',
        timeLimitReached: 'تم الوصول إلى الحد الزمني، جارٍ إيقاف التسجيل',
        loadingMoment: 'جارٍ التحميل، قد يستغرق هذا لحظة',
        recordingLimit: 'حد التسجيل: {formattedTime} (عندها سيتم إغلاق الفيديو تلقائيًا)',
        startRecording: 'بدء التسجيل',
        screenSharingMandatory: 'مشاركة الشاشة <strong>إلزامية</strong>',
        cameraNotRecorded: 'لن يتم <strong>تسجيل</strong> الكاميرا',
        cameraRecorded: 'سيتم <strong>تسجيل</strong> الكاميرا',
        audioNotRecorded: 'لن يتم <strong>تسجيل</strong> الصوت',
        audioRecorded: 'سيتم <strong>تسجيل</strong> الصوت',
        screenSharingOptional: 'مشاركة الشاشة <strong>اختيارية</strong>',
        prompt: 'مطالبة',
        textResponsePlaceholder: 'يرجى إدخال أي إجابة نصية على هذا السؤال هنا',
        adminFunctionalityDisabled: 'الوظيفة معطلة في منطقة الإدارة',
        unnamedCamera: 'كاميرا بدون اسم',
        unnamedMicrophone: 'ميكروفون بدون اسم',
        minute_singular: '{count} دقيقة',
        minute_plural: '{count} دقائق',
        second_singular: '{count} ثانية',
        second_plural: '{count} ثوانٍ',
        totalFileSize: 'إجمالي حجم الملف',
        browserSupport: 'متصفحك لا يدعم عنصر الفيديو.',
        chooseFiles: '<strong>اختر</strong> ملفاتك أو <strong>اسحبها</strong> إلى هنا',
    }
};
